import { render, staticRenderFns } from "./LabelsLayoutItem.vue?vue&type=template&id=77c99d58&"
import script from "./LabelsLayoutItem.vue?vue&type=script&lang=js&"
export * from "./LabelsLayoutItem.vue?vue&type=script&lang=js&"
import style0 from "./LabelsLayoutItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports